import * as React from "react";
import { ComponentType } from "react";
import classNames from "classnames";
import styles from "./input.module.scss";
import { IconProps } from "../icons";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  Icon?: ComponentType<IconProps>;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, Icon, ...props }, ref) => {
    const classes = classNames(
      styles.input,
      {
        [styles.withIcon]: Icon,
      },
      className,
    );

    const containerClasses = classNames(styles.inputContainer);

    return (
      <div className={containerClasses}>
        {Icon && <div className={styles.icon}>{Icon && <Icon />}</div>}
        <input type={type} className={classes} ref={ref} {...props} />
      </div>
    );
  },
);
Input.displayName = "Input";
